module.exports = __webpack_public_path__ + "img/3.67b9fe29.png";